(ns frontend.test.input-selection.number
  (:require [reagent.core :as r]
            [ui.editors.data-input :as data-input]
            [ui.view.page.view :as page]))

(def state (r/atom {}))

(defn number-input
  []
  (let [data-type :data.type/number]
    [:div.flex.flex-col
     [:div.flex.flex-row.gap-4
      [:h2.flex.shrink-0.grow-0.w-40.align-items-center.underline
       (name data-type)]
      [:div.flex.flex-col.flex-1.bg-base-light.p-4.text-base-light-text
       [data-input/view
        {:data-type data-type
         :value     (get @state data-type)
         :on-change (fn [v]
                      (swap! state assoc data-type v))}]]]]))

(defn view
  []
  [page/centered
   [number-input]])
